import { render, staticRenderFns } from "./BookFarms.vue?vue&type=template&id=71c9dbdc&"
import script from "./BookFarms.vue?vue&type=script&lang=js&"
export * from "./BookFarms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports